var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermometerTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "310px",
    height: "310px",
    viewBox: "-5 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "thermometer [#749]"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-425.000000, -4879.000000)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.0178,4736.99979 C372.359406,4736.99979 370.985766,4735.65381 370.985766,4733.99982 C370.985766,4732.69784 371.963357,4731.59885 372.966013,4731.18386 L372.966013,4729.10088 L372.966013,4728.99988 L374.971326,4728.99988 L374.971326,4729.10088 L374.971326,4731.18386 C375.973983,4731.59885 377.001706,4732.69784 377.001706,4733.99982 C377.001706,4735.65381 375.676194,4736.99979 374.0178,4736.99979 L374.0178,4736.99979 Z M373.015143,4726.99991 L375.020456,4726.99991 L375.020456,4724.99993 L373.015143,4724.99993 L373.015143,4726.99991 Z M373.015143,4721.99996 C373.015143,4721.44797 373.464333,4720.99998 374.0178,4720.99998 C374.571266,4720.99998 375.020456,4721.44797 375.020456,4721.99996 L375.020456,4722.99995 L373.015143,4722.99995 L373.015143,4721.99996 Z M376.976639,4730.02287 L376.976639,4720.99998 C376.976639,4719.89499 376.128392,4719 375.020456,4719 L373.015143,4719 C371.907208,4719 370.9607,4719.89499 370.9607,4720.99998 L370.9607,4730.02287 C369.958043,4731.10586 368.696702,4732.92484 369.065679,4734.93481 C369.42463,4736.88479 370.985766,4738.48577 372.931923,4738.88877 C376.169501,4739.55876 379,4737.11079 379,4733.99982 C379,4732.36984 377.979296,4730.93486 376.976639,4730.02287 L376.976639,4730.02287 Z",
    id: "thermometer-[#749]"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometerTemperature);
export default __webpack_public_path__ + "static/media/thermometer-temperature.1dfd67eba866986ccebd50c8ac2f4dfc.svg";
export { ForwardRef as ReactComponent };